import { isPlatform } from '@ionic/core';
import { RewriteFrames as RewriteFramesIntegration } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { Integration } from '@sentry/types';
import { logger } from '../util/logger';
import { VERSION } from '../version';
import { ApplicationConfig } from './config';

const configureSentry = (): void => {
  if (ApplicationConfig.env !== 'local') {
    logger.info('configuring sentry');

    const integrations: Integration[] = [];

    if (isPlatform('capacitor') && isPlatform('android')) {
      integrations.push(
        new RewriteFramesIntegration({
          root: 'http://localhost',
        })
      );
    }

    Sentry.init({
      dsn: 'https://181939e7ce4c407aa3a75ea1c4cfb819@o204309.ingest.sentry.io/5443863',
      environment: ApplicationConfig.env,
      release: `${VERSION}-${ApplicationConfig.env}`,
      tracesSampleRate: 0.1,
      autoSessionTracking: false,
      beforeSend,
      integrations,
      ignoreErrors: ['ResizeObserver loop limit exceeded'],
      /**
       * When logging objects, show nested-object depth to 5 levels.
       * Sentry's default is 3 which is insufficient for this app.
       */
      normalizeDepth: 5,
    });

    logger.info('sentry config complete');
  }
};

const setSentryUserContext = (email: string): void => {
  logger.info('setting user context on sentry', { email });
  Sentry.setUser({
    email,
  });
};

const exclusionList = [
  'Network Error',
  'timeout',
  'The network connection was lost',
  'CodeMismatchException',
];

const beforeSend = <T>(
  event: T,
  hint: Sentry.EventHint | undefined
): T | null => {
  const error = hint?.originalException;

  let message: string;
  if (typeof error === 'string') {
    message = error;
  }

  if (error instanceof Error && error?.message) {
    message = error.message;
  }

  const exclude = exclusionList.find(
    (exclusion) => message?.includes(exclusion)
  );

  if (exclude) {
    return null;
  }

  return event;
};

export { configureSentry, setSentryUserContext };
